<template>
    <MenuLayout />
    <main class="flex-shrink-0">
      <HeaderLayout :name="name" />
      <div v-if="isAdmin != 'yes'" class="embed-responsive embed-responsive-21by9" style="height: 720px;">
          <iframe :src="thpUrl" class="embed-responsive-item"></iframe>
      </div>
      <div v-else class="container mt-4">
          <div style="display: flex; justify-content: center; align-items: center; ">
              <p>Data tidak tersedia.</p>
          </div>
      </div>
    </main>
  </template>
  
  <script>
  import MenuLayout from "../components/MenuLayout.vue";
  import HeaderLayout from "../components/HeaderLayout.vue";
  import { config } from '../config.js';

  export default {
    name: "TakeHomePay",
    components: { MenuLayout, HeaderLayout },
    data() {
      return {
        name: '',
        isAdmin: '',
      };
    },
    computed: {
        thpUrl() {
            const periode = new Date().toISOString().slice(0, 7) + '-01';
            const token = localStorage.getItem('tokenMobile');
            // return `https://garuda.bkd.jatengprov.go.id/backend/api/thp?token=${token}&periode=${periode}`;
            return config.apiUrl+'/api/thp?token='+token+'&periode='+periode;
        },
    },
    async created() {
      try {
        const status = localStorage.getItem('status');
        if (status != 'valid') {
          this.$router.push('/');
        }
        this.name = localStorage.getItem('profileName');
        this.isAdmin = localStorage.getItem('isAdmin');
      } catch (err) {
        this.$router.push('/');
      }
    },
  };
  </script>